import { get_axios_file_download_instance,get_axios_instance, get_axios_report_instance , api_new_report_variables, errorHandler, api_variables } from '@/apis/variables.js';
// import Vue from 'vue';

var axios_instance_month_variance = get_axios_report_instance(api_new_report_variables.SERVICE_DOWNLOAD_MONTH_VARIANCE); // PL_3064  //
var axios_instance_active_employees = get_axios_report_instance(api_new_report_variables.SERVICE_DOWNLOAD_ACTIVE_EMPLOYEES);
var axios_instance_negative_salary = get_axios_report_instance(api_new_report_variables.SERVICE_DOWNLOAD_NEGATIVE_SALARY);
var axios_instance_zero_salary = get_axios_report_instance(api_new_report_variables.SERVICE_DOWNLOAD_ZERO_SALARY);
var axios_instance_employee_master = get_axios_report_instance(api_new_report_variables.SERVICE_DOWNLOAD_EMPLOYEE_MASTER);
var axios_instance_pan_not_available = get_axios_report_instance(api_new_report_variables.SERVICE_DOWNLOAD_PAN_NOT_AVAILABLE);
var axios_instance_it_reconciliation = get_axios_report_instance(api_new_report_variables.SERVICE_DOWNLOAD_IT_RECONCILIATION);
var axios_instance_income_tax = get_axios_report_instance(api_new_report_variables.SERVICE_DOWNLOAD_INCOME_TAX);
var axios_instance_tds_report = get_axios_report_instance(api_new_report_variables.SERVICE_DOWNLOAD_TDS_REPORT);
var axios_instance_etds_report = get_axios_report_instance(api_new_report_variables.SERVICE_DOWNLOAD_ETDS_REPORT);
var axios_instance_ytd_tds_report = get_axios_report_instance(api_new_report_variables.SERVICE_DOWNLOAD_YTD_TDS_REPORT);
var axios_instance_ctc_report = get_axios_report_instance(api_new_report_variables.SERVICE_DOWNLOAD_CTC_REPORT);
var axios_instance_fnf_report = get_axios_report_instance(api_new_report_variables.SERVICE_DOWNLOAD_FNF_REPORT);
var axios_instance_salary_on_hold = get_axios_report_instance(api_new_report_variables.SERVICE_DOWNLOAD_SALARY_ON_HOLD);
var axios_instance_salary_variance = get_axios_report_instance(api_new_report_variables.SERVICE_DOWNLOAD_SALARY_VARIANCE);
var axios_instance_cost_center_report = get_axios_report_instance(api_new_report_variables.SERVICE_DOWNLOAD_COST_CENTER_REPORT);
var axios_instance_pt_report = get_axios_report_instance(api_new_report_variables.SERVICE_PT_REPORT);
var axios_instance_lwf_report = get_axios_report_instance(api_new_report_variables.SERVICE_LWF_REPORT);
var axios_instance_detailed_pf_report = get_axios_report_instance(api_new_report_variables.SERVICE_DETAILED_PF_REPORT);
var axios_instance_pf_report = get_axios_report_instance(api_new_report_variables.SERVICE_PF_REPORT);
var axios_instance_esi_v2_report = get_axios_report_instance(api_new_report_variables.SERVICE_ESI_V2_REPORT);
var axios_instance_lwf_v1_report = get_axios_report_instance(api_new_report_variables.SERVICE_LWF_V1_REPORT);
var axios_instance_it_compuation_report = get_axios_report_instance(api_new_report_variables.SERVICE_IT_COMPUATION_REPORT);
var axios_instance_salary_register_report = get_axios_report_instance(api_new_report_variables.SERVICE_SALARY_REGISTER_REPORT);
var axios_instance_cost_center_wise_report = get_axios_report_instance(api_new_report_variables.SERVICE_COST_CENTER_WISE_REPORT);
var axios_instance_cumulative_salary_register_report = get_axios_report_instance(api_new_report_variables.SERVICE_CUMULATIVE_SALARY_RIGISTER_REPORT);
var axios_instance_head_count_report = get_axios_report_instance(api_new_report_variables.SERVICE_HEAD_COUNT_REPORT);
var axios_instance_master_salary_report = get_axios_report_instance(api_new_report_variables.SERVICE_MASTER_SALARY_REPORT);
var axios_instance_one_time_payment_report = get_axios_report_instance(api_new_report_variables.SERVICE_ONE_TIME_PAYMENT_REPORT);
var axios_instance_employee_master_columns_report = get_axios_report_instance(api_new_report_variables.SERVICE_EMPLOYEE_MASTER_COLUMNS_REPORT);
var axios_instance_ffs_salary_registed_report = get_axios_report_instance(api_new_report_variables.SERVICE_FFS_SALARY_REGISTER_REPORT);
var axios_instance_master_ctc_report = get_axios_report_instance(api_new_report_variables.SERVICE_MASTER_CTC_REPORT);
var axios_instance_pending_fnf_report = get_axios_report_instance(api_new_report_variables.SERVICE_PENDING_FNF_REPORT);
var axios_instance_it_reconciliation_detailed_report = get_axios_report_instance(api_new_report_variables.SERVICE_IT_RECONCILIATION_DETAILED_REPORT);
var axios_instance_bank_advice_consolidated_report = get_axios_report_instance(api_new_report_variables.SERVICE_BANK_ADVICE_CONSOLIDATED_REPORT);
var axios_instance_bank_advice_with_IFSC_bank_wise_report = get_axios_report_instance(api_new_report_variables.SERVICE_BANK_ADVICE_WITH_IFSC_BANK_WISE_REPORT);
var axios_instance_report_data_transfer = get_axios_instance(api_variables.SERVICE_REPORT_DATA_TRANSFER);
var axios_instance_pay_register_report = get_axios_report_instance(api_new_report_variables.SERVICE_PAY_REGISTER_STANDARD_REPORT);
var axios_instance_pay_register_without_std_report = get_axios_report_instance(api_new_report_variables.SERVICE_PAY_REGISTER_WITHOUT_STANDARD_REPORT);
var axios_instance_download_employee_master = get_axios_report_instance(api_new_report_variables.SERVICE_DOWNLOAD_STD_EMPLOYEE_MASTER);
var axios_instance_download_override_report = get_axios_report_instance(api_new_report_variables.SERVICE_DOWNLOAD_OVERRIDE_REPORTS);
var axios_instance_download_freeze_std_reports = get_axios_instance(api_variables.SERVICE_STD_FREEZE);
var axios_instance_download_nps_reports = get_axios_instance(api_variables.SERVICE_NPS_REPORT);
var axios_instance_download_salary_report_it_report_download_enable_on_payroll = get_axios_instance(api_variables.SERVICE_SALARY_IT_REPORT_DOWNLOAD_CHECK_ON_PAYROLL)
var axios_instance_download_bank_report = get_axios_instance(api_variables.SERVICE_DOWNLOAD_BANK_REPORT);
var axios_instance_download_bulk_reports = get_axios_report_instance(api_new_report_variables.SERVICE_DOWNLOAD_BULK_REPORTS);

const state = {
    data: [],
    isFetching: false,
};

const mutations = {
    set: (state, payload) => {
        state.data = payload;
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

}
const actions = {
    async downloadMonthVarianceReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_month_variance.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },

    async downloadActiveEmployeeReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_active_employees.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },

    async downloadNegativeSalaryReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_negative_salary.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },

    async downloadZeroSalaryReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_zero_salary.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },

    async downloadEmployeeMasterReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_employee_master.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },

    async downloadPanNotAvailableReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_pan_not_available.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },

    async downloadItReconciliationReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_it_reconciliation.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },

    async downloadIncomeTaxReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_income_tax.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },

    async downloadTDSReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_tds_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },

    async downloadETDSReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_etds_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },

    async downloadYtdTdsReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_ytd_tds_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadCTCreports({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_ctc_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadFNFreports({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_fnf_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadsalaryOnHoldreports({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_salary_on_hold.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadsalaryVariance({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_salary_variance.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadCostCenterReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_cost_center_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadPTReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_pt_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadLWFreport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_lwf_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadPFDetailedreport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_detailed_pf_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadPFreport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_pf_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadESIv2report({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_esi_v2_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadLWFv1report({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_lwf_v1_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadITcompuationReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_it_compuation_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadSalaryRegisterReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_salary_register_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadCostCenterWiseReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_cost_center_wise_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadCumulativeSalaryRegisterReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_cumulative_salary_register_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadHeadCountReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_head_count_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadMasterSalaryReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_master_salary_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadOneTimePaymentReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_one_time_payment_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadEmployeeMasterColumnsReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_employee_master_columns_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadFFSsalaryRegisterReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_ffs_salary_registed_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadMasterCtcReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_master_ctc_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadPendingFNFreport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_pending_fnf_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadItReconciliationDetailedReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_it_reconciliation_detailed_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadBankAdviceConsolidatedReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_bank_advice_consolidated_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadBankAdviceWithIFSCBankWiseReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_bank_advice_with_IFSC_bank_wise_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadPayRegisterWithStandardReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_pay_register_report.get('', {
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadStdEmployeeMaster({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_download_employee_master.get('', {
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },
    async downloadOverrideReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_download_override_report.get('', {
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },

    async downloadNpsReport({ commit }, payload) {
        try {
            let res = await axios_instance_download_nps_reports.get('', {
                params: {
                    ...payload
                }
            } );
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", payload + ".xlsx");
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async downloadPayRegisterWithOutStandardReport({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            let res = await axios_instance_pay_register_without_std_report.get('',{
                params: {
                    ...payload
                }
            } );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", payload + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },

    async reportDataTransfer({ commit }, payload) {
        //console.log("Payload",payload);
        try {
            
            let res = await axios_instance_report_data_transfer.post('',
                    payload
             );
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            return res;
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },

    async downloadStdReports({ commit }, payload) {
        try {
            let res = await axios_instance_download_freeze_std_reports.get('',{
                params: {
                    ...payload
                }
            } );
            if (res && res.data && res.data.payload) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", payload + ".xlsx");
                document.body.appendChild(link);
                link.click();
                return res;
            } else {
                return res;
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async checkPayrollCompletedToEnableReportDownload({commit},payload){
        try{
            let res = await axios_instance_download_salary_report_it_report_download_enable_on_payroll.get('',{
                params:{
                    le_id:payload.le_id,
                    type:payload.type
                }
            });
                return res
        }catch(error){
            throw errorHandler(error.response)
        }
    },
     async downloadBankReport({ commit }, payload) {
        try {
            let res = await axios_instance_download_bank_report.get('', {
                params: {
                    ...payload
                }
            } );
            if (res.data) {
                return res;
            }
        } catch (error) {
            //console.log(error);
            throw errorHandler(error.response);
        }
    },

    async downloadBulkReports({ commit }, payload) {
        try {
            let res = await axios_instance_download_bulk_reports.get('', {
                params: {
                    ...payload
                }
            });
            if (res.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.setAttribute("download", "bulk_reports.xlsx");
                document.body.appendChild(link);
                link.click();
                return res;
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

}

export default {
    namespaced: true,
    actions,
    mutations,
    state
};
